import { Box, Chip } from '@mui/material';
import { Campaign, HelpOutline, PhoneAndroid } from '@mui/icons-material';

interface Props {
  noticesCount: number;
  faqsCount: number;
  totalDevices: number;
}

const QuickStatsBar = ({ noticesCount, faqsCount, totalDevices }: Props) => (
  <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
    <Chip
      icon={<Campaign sx={{ fontSize: 16 }} />}
      label={`활성 공지 ${noticesCount}개`}
      size="small"
      sx={{ fontWeight: 600, fontSize: '0.75rem', bgcolor: '#fff7ed', color: '#c2410c', border: '1px solid #fed7aa', '& .MuiChip-icon': { color: '#c2410c' } }}
    />
    <Chip
      icon={<HelpOutline sx={{ fontSize: 16 }} />}
      label={`FAQ ${faqsCount}개`}
      size="small"
      sx={{ fontWeight: 600, fontSize: '0.75rem', bgcolor: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0', '& .MuiChip-icon': { color: '#15803d' } }}
    />
    <Chip
      icon={<PhoneAndroid sx={{ fontSize: 16 }} />}
      label={`총 기기 ${totalDevices.toLocaleString()}대`}
      size="small"
      sx={{ fontWeight: 600, fontSize: '0.75rem', bgcolor: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', '& .MuiChip-icon': { color: '#1d4ed8' } }}
    />
  </Box>
);

export default QuickStatsBar;
